import * as XLSX from 'xlsx';

const FORMATO_PADRAO_NUMERICO = '#,##0.00';

const limitarNomeAba = (nome) => {
    if (typeof nome !== 'string') {
        return 'Planilha';
    }
    return nome.length > 31 ? nome.slice(0, 31) : nome;
};

const calcularLarguraColunas = (dados) => {
    if (!Array.isArray(dados) || dados.length === 0) {
        return [];
    }

    const totalColunas = dados[0].length;
    return Array.from({ length: totalColunas }).map((_, coluna) => {
        const largura = dados.reduce((maximo, linha) => {
            const valor = linha?.[coluna];
            if (valor === null || valor === undefined) {
                return maximo;
            }

            const texto = typeof valor === 'number'
                ? valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : String(valor);
            return Math.max(maximo, texto.length + 2);
        }, 10);

        return { wch: Math.min(Math.max(largura, 12), 40) };
    });
};

export function exportarXLSX({
    arquivo,
    aba,
    cabecalho,
    linhas,
    colunasNumericas = [],
    formatoNumerico = FORMATO_PADRAO_NUMERICO,
}) {
    const cabecalhoArray = Array.isArray(cabecalho) ? cabecalho : [];
    const linhasArray = Array.isArray(linhas) ? linhas : [];

    const dados = [
        cabecalhoArray,
        ...linhasArray.map((linha) => linha.map((valor) => (valor === undefined || valor === null ? '' : valor))),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(dados);

    const totalLinhas = dados.length;
    colunasNumericas.forEach((coluna) => {
        for (let linha = 1; linha < totalLinhas; linha += 1) {
            const endereco = XLSX.utils.encode_cell({ c: coluna, r: linha });
            const celula = worksheet[endereco];
            if (!celula) {
                continue;
            }

            const valorOriginal = linhasArray[linha - 1]?.[coluna];
            const numerico = typeof valorOriginal === 'number' ? valorOriginal : Number(valorOriginal);

            if (Number.isFinite(numerico)) {
                celula.v = numerico;
                celula.t = 'n';
                celula.z = formatoNumerico;
            } else {
                celula.t = 's';
            }
        }
    });

    worksheet['!cols'] = calcularLarguraColunas(dados);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, limitarNomeAba(aba));
    XLSX.writeFile(workbook, `${arquivo}.xlsx`, { bookType: 'xlsx', compression: true });
}

